import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';

@withText(props => ({
    mediaNumber: <Text id='input.mediaNumber-help'>mediaNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class NewMedia extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('media'),
        };
    }

    loadAll = async (props = this.props, emptyFirst = true) => {
        const { id } = props;
        const { mediaStore } = this.props.stores;
        if (emptyFirst) {
            mediaStore.updateKeyValue('media', {});
        }
        await mediaStore.load(id, false, { addData: ['races', 'tags'], query: {} });
    }

    createMedia = async () => {
        const { callback = () => {}, installation } = this.props;
        const { mediaStore, installationStore } = this.props.stores;
        const { newMedia } = mediaStore;

        const response = await mediaStore.insert(newMedia);
        const media = response?.data?.media;

        mediaStore.updateKeyValue('newMedia', {});
        callback();
    }

    chooseItem = (e) => {
        const { id } = e.target.closest('.similar-item').dataset;
        const { mediaStore } = this.props.stores;
        const { foundList } = mediaStore;
        const item = foundList.find((item) => item.id === parseInt(id, 10));
        mediaStore.updateKeyValue('newMedia', {
            ...item,
        });
        mediaStore.resetSearch();
    }

    toggleSimilar = () => {
        const { showSimilar } = this.state;
        this.setState({
            showSimilar: !showSimilar,
        });
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { week, isNew, drawerLevel, installation, lookupArray } = this.props;
        const { sections, showSimilar } = this.state;
        const { userStore, mediaStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newMedia, foundList, foundListKeys } = mediaStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');


        return (<>
            <div class='w-100 d-flex justify-content-center position-relative'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    {/* <xmp>{JSON.stringify(installation, null, 4)}</xmp> */}
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        {isNew ? <Text id='media.new'>New media</Text> : <Text id='media.edit'>Edit media</Text>}
                        {installation?.id && <>
                            <span class='ms-2'>
                                :: {installation.name}
                            </span>
                        </>}
                    </div>

                    {showSimilar && foundList?.length > 0 && <>
                        <div class='w-100 d-flex flex-column justify-content-start'>
                            <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                                <div class='mx-4 font-weight-lighter px-3 py-1 text-muted' >
                                    <small class='text-uppercase'>
                                        <Text id='media.similar'>Similar medias</Text>
                                    </small>
                                </div>
                                <div class={`${darkmode ? 'bg-darkmode' : 'bg-lightmode'} mx-4 d-flex flex-column px-0 overflow-auto`} style='font-size: 1.1em; border-radius: 10px; max-height: 35vh;'>
                                    {foundList.map((item, idx) => {
                                        return(<>
                                            <div class='d-flex flex-row justify-content-between align-items-center'>
                                                <div
                                                    class='flex-fill similar-item py-2 px-3'
                                                    data-id={item.id}
                                                    onClick={this.chooseItem}
                                                >
                                                    {item.name}
                                                    <span class='font-weight-lighter text-muted ms-3'>{item.mediaNumber}</span>
                                                </div>
                                                {/* {item.images[0] && <>
                                                    <div>
                                                        <div class=''>
                                                            <img src={`${item.images[0].s3MediumLink}`} class='rounded-lg img-fluid' style='max-height: 45px;' />
                                                        </div>
                                                    </div>
                                                </>} */}
                                            </div>
                                        </>);
                                    })}
                                </div>
                            </div>
                        </div>
                    </>}

                    <div class='w-100 d-flex flex-column justify-content-start'>
                        <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                            <FormFieldsCompact
                                stores={this.props.stores}
                                sections={sections}
                                holdingStore={mediaStore}
                                objectName={isNew ? 'newMedia' : 'media'}
                                isNew={isNew}
                                drawerLevel={drawerLevel}
                                isAdmin={false}
                                hideAdmin={true}
                                lookupArray={lookupArray}
                                rightHeader={isNew && foundList?.length > 0 ? <span class='text-success font-weight-bold'><i class='fa-solid fa-circle-info' /> Similar medias ({foundList.length})</span> : null}
                                rightHeaderClick={this.toggleSimilar}
                            />
                        </div>
                    </div>
                </div>



            </div>

            {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                <button type='button' class='btn btn-primary rounded-pill' onClick={this.createMedia}>
                    {isNew ? <Text id='media.create'>Create media</Text> : <Text id='media.save'>Save media</Text>}
                </button>
            </div>}
        </>);
    }
}

export default NewMedia;
